import { ReactNode } from 'react';
import { ListItemButton, ListItemText } from '@mui/material';

type ExternalGeoEventListItemProps = {
  icon?: ReactNode;
  onClick?: () => void;
  primary: string | ReactNode;
  secondary: string | ReactNode;
};

const noop = (): void => {};

export const ExternalGeoEventListItem = (
  props: ExternalGeoEventListItemProps,
): JSX.Element => {
  const { icon, onClick = noop, primary, secondary } = props;

  return (
    <ListItemButton divider onClick={onClick}>
      <ListItemText
        primary={primary}
        secondary={secondary}
        slotProps={{
          primary: { color: 'secondary', variant: 'h4' },
          secondary: {
            variant: 'body1',
            color: 'textPrimary',
            sx: { fontWeight: 'fontWeightMedium' },
          },
        }}
      />
      {icon ?? null}
    </ListItemButton>
  );
};
